import type { AuthUser, OtpChallenge } from "@/lib/api";

const AUTH_KEY = "jazia_auth";
const CHALLENGE_KEY = "jazia_otp_challenge";

export type StoredAuth = {
  token: string;
  user: AuthUser;
};

export type StoredChallenge = {
  userId: string;
  purpose: "LOGIN" | "SIGNUP";
  destinations: OtpChallenge["destinations"];
  message?: string;
};

export function saveAuth(auth: StoredAuth) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
}

export function updateStoredUser(user: AuthUser) {
  const current = getAuth();
  if (!current) return;
  saveAuth({ ...current, user });
}

export function getAuth(): StoredAuth | null {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? (JSON.parse(raw) as StoredAuth) : null;
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
}

export function saveChallenge(challenge: StoredChallenge) {
  sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(challenge));
}

export function getChallenge(): StoredChallenge | null {
  try {
    const raw = sessionStorage.getItem(CHALLENGE_KEY);
    return raw ? (JSON.parse(raw) as StoredChallenge) : null;
  } catch {
    return null;
  }
}

export function clearChallenge() {
  sessionStorage.removeItem(CHALLENGE_KEY);
}
